<template>
  <v-container>
    <v-spacer/>
    <v-row v-if="!passwordResetSubmitted">
      <v-col cols="8" offset="2">
        <v-form ref="form" class="mt-5 py-3" @submit.prevent="submitPasswordReset">
          <v-text-field
              v-model="password1"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required]"
              :type="showPassword ? 'text' : 'password'"
              label="Password"
              @click:append="showPassword = !showPassword"
          ></v-text-field>
          <v-text-field
              v-model="password2"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required, rules.password]"
              :type="showPassword ? 'text' : 'password'"
              label="Confirm Password"
              @click:append="showPassword = !showPassword"
          ></v-text-field>
          <v-spacer/>
          <v-btn block class="mt-5 " type="submit">
            Change Password
          </v-btn>
        </v-form>
      </v-col>
    </v-row>
    <div v-else class="text-center">
      <h1>Password Changed</h1>
      <p>Your password has been changed successfully.</p>
      <p>
        <router-link to="/login">
          Login
        </router-link>
      </p>

    </div>
  </v-container>
</template>

<script>

import rules from '../helpers/forms'

export default {
  name: 'PasswordChange',
  data() {
    return {
      password1: '',
      password2: '',
      passwordResetSubmitted: false,
      showPassword: false,
      rules: rules
    }
  },
  mounted() {
    this.rules.password = value => this.password1 === this.password2 || 'Passwords Must Match'
  },
  methods: {
    submitPasswordReset() {
      var valid = this.$refs.form.validate()
      if (valid) {
        this.$store.dispatch('passwordChange', {password: this.password1, token: this.$route.params.token})
            .then(response => {
              this.passwordResetSubmitted = true
            })
      }
    }
  }
}
</script>

<style>
</style>
